import React from 'react';
import AudioButton from './AudioButton';
import { cn } from '../../lib/utils';

const PhraseCard = ({ phrase, className }) => {
  const { en, pt, audio } = phrase;

  return (
    <div className={cn('phrase-card', className)}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex-1 min-w-0">
          <p className="font-medium text-foreground">{en}</p>
          <p className="text-sm text-muted-foreground mt-1">{pt}</p>
        </div>
        {audio && (
          <AudioButton text={en} size="sm" />
        )}
      </div>
    </div>
  );
};

export default PhraseCard;
